export const environment = {
  production: true,
  title: 'Production Environment Heading',
  apiURL: 'https://servicmaq.lubrikuv.com/backend/'
  // apiURL: 'https://servicmaq2.lubrikuv.com/backend/'
};
